import React from 'react';
import PickupRequestPage from './PickupRequestPage';

const CustomerPickupRequest = () => (
  <PickupRequestPage
    requestType="CUSTOMER"
    title="Customer Pickup Request"
    subtitle="Customers can request order pickup — register and track pickup intents here."
  />
);

export default CustomerPickupRequest;